export default __webpack_public_path__ + "static/media/email.26065d36.png";